import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import App from './App';
import Login from './pages/Login';
import PrivateRoute from './components/RutasPrivadas/PrivateRoute'
import axios from 'axios';
import { useLocalState } from './util/useLocalStorage';

const AppWrapper = (props) => {
    let location = useLocation();
    const [usuario, setUsuario] = useState("");
    const [username, setUsername] = useLocalState("", "username");
    const [roles, setRoles] = useLocalState("", "roles");

    /**JWT */
    const [jwt, setJwt] = useLocalState("", "jwt");
    /**Headers Token */

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={
               
                <PrivateRoute>
                    <App />
                </PrivateRoute>


            } />
        </Routes>
    );
};

export default AppWrapper;
